export const aboutData = {
  brand: {
    name: '农民影视',
    slogan: '让每一个人都能享受高清影视的魅力',
    founded: 2018,
    description: '农民影视成立于2018年，是国内领先的免费高清影视在线观看平台。我们致力于为广大影视爱好者提供最优质、最流畅的在线观影体验，让高品质影视内容惠及每一个人。',
  },
  stats: [
    { label: '累计用户', value: '5,800万+' },
    { label: '影视资源', value: '10万+' },
    { label: '日均播放', value: '2,300万+' },
    { label: '用户好评率', value: '98.6%' },
  ],
  values: [
    {
      title: '免费开放',
      description: '我们坚信优质影视内容应该向所有人开放。农民影视始终坚持免费模式，不收取任何会员费用，让每一位用户都能畅享高清影视盛宴。',
      icon: 'ri-open-arm-line',
    },
    {
      title: '高清品质',
      description: '采用先进的视频编码技术和全球CDN加速网络，确保每一部影片都能以最高画质流畅播放。支持1080P、4K等多种清晰度选择。',
      icon: 'ri-4k-line',
    },
    {
      title: '内容丰富',
      description: '涵盖动作、喜剧、爱情、科幻、恐怖、剧情、动画、纪录片等多个品类，同时拥有海量热门电视剧资源，满足不同用户的观影需求。',
      icon: 'ri-stack-line',
    },
    {
      title: '用户体验',
      description: '简洁直观的界面设计，智能化的内容推荐算法，强大的搜索功能，让用户快速找到想看的影片。即点即播，无需等待。',
      icon: 'ri-user-heart-line',
    },
  ],
  testimonials: [
    {
      name: '王大明',
      role: '资深影迷',
      content: '农民影视是我用过最好的免费影视平台！资源特别全，画质也很清晰，最关键的是播放非常流畅，几乎没有缓冲。每天都来这里追剧看电影，强烈推荐！',
      rating: 5,
    },
    {
      name: '李小红',
      role: '全职妈妈',
      content: '孩子特别喜欢看动画片，农民影视上的动画资源又多又好。我自己也能找到很多好看的电视剧，不用到处找资源了，真的很方便。',
      rating: 5,
    },
    {
      name: '张伟',
      role: '大学生',
      content: '宿舍网速一般，但用农民影视看高清电影基本不卡。分类也很清晰，找片子特别方便。而且完全免费，对我们学生党来说太友好了！',
      rating: 5,
    },
    {
      name: '陈美丽',
      role: '白领',
      content: '下班后最喜欢在农民影视上看看电影放松。界面简洁干净，没有烦人的弹窗广告。片源更新也很快，新上映的大片很快就能看到。',
      rating: 5,
    },
    {
      name: '刘建国',
      role: '退休教师',
      content: '退休在家喜欢看老电影和纪录片，农民影视上有很多经典老片。操作也很简单，我们老年人也能轻松使用。感谢农民影视！',
      rating: 5,
    },
    {
      name: '赵小芳',
      role: '自由职业者',
      content: '农民影视的电视剧资源太全了！追剧神器！而且可以记住播放进度，下次接着看，这个功能太贴心了。画质和流畅度都没得说！',
      rating: 5,
    },
  ],
  contact: {
    email: 'service@nongminyingshi.com',
    phone: '400-888-6666',
    address: '北京市朝阳区建国路88号SOHO现代城A座15层',
    wechat: '农民影视官方',
    weibo: '@农民影视',
    workingHours: '周一至周日 9:00 - 21:00',
  },
  faqs: [
    {
      question: '农民影视真的完全免费吗？',
      answer: '是的，农民影视始终坚持免费模式。我们通过广告收入来维持运营，不会向用户收取任何费用。您可以免费观看平台上的所有影视内容。',
    },
    {
      question: '需要注册账号才能观看吗？',
      answer: '不需要。农民影视无需注册即可直接观看所有内容。如果您想收藏影片或记录观看历史，可以选择注册账号，但这完全不是必须的。',
    },
    {
      question: '支持哪些设备观看？',
      answer: '农民影视支持电脑、平板、手机等所有主流设备。您可以通过浏览器直接访问，无需下载任何APP。我们采用响应式设计，在不同设备上都能获得良好的观影体验。',
    },
    {
      question: '视频画质最高支持多少？',
      answer: '我们支持多种清晰度选择，包括标清、高清720P、全高清1080P以及超高清4K。具体可选择的清晰度取决于影片源和您的网络状况。',
    },
    {
      question: '为什么有些影片无法播放？',
      answer: '如果遇到无法播放的情况，可能是该影片的源链接暂时失效。您可以尝试刷新页面或切换其他清晰度。如果问题持续存在，欢迎通过客服渠道反馈，我们会尽快修复。',
    },
    {
      question: '影片多久更新一次？',
      answer: '我们的内容团队每天都会更新最新上映的电影和热播电视剧。一般来说，热门大片上映后1-2周内就会上线，电视剧会同步更新最新剧集。',
    },
    {
      question: '如何联系客服？',
      answer: '您可以通过以下方式联系我们的客服团队：发送邮件至 service@nongminyingshi.com，或拨打客服热线 400-888-6666。我们的工作时间是周一至周日 9:00 - 21:00。',
    },
  ],
};